import React from 'react'
import KmlComponent from '../components/KmlComponent'
import { sendService, sendFile, answerOk } from "../../../Services/service";

import '../style.css'

class KmlContainer extends React.Component {
  state = {
    tableContent: [],
    upload: false,
    uploadOk: false,
    loading: true,
    file: null,
    fileError: false,
    name: '',
    nameError: false,
    control: {
      count: 0,
      page: 0,
      pages: 0,
      pageSize: 5
    },
    change: false,
  }

  fileSelect = () => document.getElementById('kml-input-file').click()
  fileChange = (e) => this.setState({ file: e.target.files[0], upload: false, uploadOk: false })

  handlerText = (e) => this.setState({ name: e.target.value, upload: false, uploadOk: false })

  uploadFile = async () => {
    const state = {
      fileError: this.errorCheck('file'),
      nameError: this.errorCheck('name'),
    }
    const error = Object.keys(state).reduce((pre, cur) => pre || state[cur], false)
    this.setState({ ...state })
    if (error) return
    this.setState({ loading: true })
    const data = new FormData()
    data.append('file', this.state.file)
    data.append('name', this.state.name)
    data.append('pageSize', this.state.control.pageSize)
    const file = (ok) => {
      if (ok) {
        this.getTable(0)
        this.setState({ change: true })
      }
      this.setState({
        loading: false,
        upload: true,
        uploadOk: ok,
        name: '',
      })
    }
    const fileOk = () => { file(true) }
    const fileError = () => { file(false) }
    const funcs = {
      start: () => { },
      end: fileOk,
      onprogress: () => { },
      error: fileError
    }
    let url = `/api/v1/dashboard/uploadlayer`;
    sendFile(url, data, funcs);
  }

  errorCheck = (key) => {
    return (!this.state[key] || this.state[key] === '')
  }

  activateLayer = async (id, state) => {
    this.setState({ loading: true })
    let url = `/api/v1/dashboard/setactivelayer/${id}/${state}`;
    var res = await sendService(url);
    if (!answerOk(res, () => this.setState({ upload: true, uploadOk: false }))) return
    this.setState({ upload: false, uploadOk: false, change: true })
    this.getTable()
  }

  componentDidMount() { this.getTable(0) }

  dobleClickTextHandler = (id) => {
    this.setState({
      tableContent: this.state.tableContent.map((item, index) => {
        if (index === id) return { ...item, edit: true }
        return { ...item }
      })
    })
  }

  updateLayer = async (id, name) => {
    this.setState({ loading: true, tableContent: [], change: true })
    let url = `/api/v1/dashboard/updateLayer/${id}/${name}`
    await sendService(url);
    this.getTable();
  }

  deleteLayer = async (id) => {
    this.setState({ loading: true, tableContent: [], change: true })
    let url = `/api/v1/dashboard/deleteKml/${id}`
    await sendService(url);
    this.getTable();
  }

  cancelLayer = (id) => {
    this.setState({
      tableContent: this.state.tableContent.map(item => {
        if (item.id === id) return { ...item, edit: false }
        return { ...item }
      })
    })
  }

  getTable = async () => {
    let url = `/api/v1/dashboard/getKmlList`;
    var res = await sendService(url);
    console.log('res', res)
    if (!answerOk(res, () => this.props.onClose())) return

    this.setState({
      tableContent: res.response.map(item => { return { ...item, edit: false } }),
      loading: false
    })
  }

  close = () => {
    if (this.state.change) this.props.signalUpdate()
    this.props.onClose()
  }

  render() {
    return (
      <KmlComponent
        fileSelect={this.fileSelect}
        fileChange={this.fileChange}
        handlerText={this.handlerText}
        activateLayer={this.activateLayer}
        uploadFile={this.uploadFile}
        pageChange={this.getTable}
        dobleClickTextHandler={this.dobleClickTextHandler}
        updateLayer={this.updateLayer}
        cancelLayer={this.cancelLayer}
        deleteLayer={this.deleteLayer}
        close={this.close}
        state={this.state}
      />
    )
  }
}

export default KmlContainer;